// Format angka, Rupiah & tanggal — port 1:1 dari public/js/core.js v1 (keluaran teks harus identik).

export const TZ = 'Asia/Jakarta';

export const num = (n: unknown): string => Number(n || 0).toLocaleString('id-ID');

/** "Rp1.250.000" / "-Rp5.000" (format v1 — berbeda dari rupiah() di @sj/shared untuk angka negatif). */
export const rp = (n: unknown): string => {
  const v = Math.round(Number(n) || 0);
  return `${v < 0 ? '-' : ''}Rp${num(Math.abs(v))}`;
};

export const rpShort = (n: number): string => {
  const a = Math.abs(n);
  if (a >= 1e9) return `${(n / 1e9).toLocaleString('id-ID', { maximumFractionDigits: 1 })} M`;
  if (a >= 1e6) return `${(n / 1e6).toLocaleString('id-ID', { maximumFractionDigits: 1 })} jt`;
  if (a >= 1e3) return `${Math.round(n / 1e3).toLocaleString('id-ID')} rb`;
  return num(n);
};

/** ISO / "YYYY-MM-DD HH:MM:SS" (UTC) / "YYYY-MM-DD" (tanggal WIB) → Date. */
export const toDate = (s: string): Date =>
  new Date(
    /Z|[+-]\d\d:?\d\d$/.test(s) ? s : /^\d{4}-\d{2}-\d{2}$/.test(s) ? `${s}T00:00:00+07:00` : `${String(s).replace(' ', 'T')}Z`,
  );

type D = string | null | undefined;
export const fmtDT = (s: D): string =>
  s
    ? toDate(s).toLocaleString('id-ID', { timeZone: TZ, day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })
    : '-';
export const fmtDay = (s: D): string =>
  s ? toDate(s).toLocaleDateString('id-ID', { timeZone: TZ, day: 'numeric', month: 'short', year: 'numeric' }) : '-';
export const fmtDayShort = (s: D): string =>
  s ? toDate(s).toLocaleDateString('id-ID', { timeZone: TZ, day: 'numeric', month: 'short' }) : '-';

export const ago = (s: D): string => {
  if (!s) return 'belum ada sinyal';
  const m = Math.round((Date.now() - toDate(s).getTime()) / 60000);
  if (m < 1) return 'baru saja';
  if (m < 60) return `${m} mnt lalu`;
  if (m < 1440) return `${Math.floor(m / 60)} jam lalu`;
  return fmtDT(s);
};

/** Tanggal hari ini (WIB) 'YYYY-MM-DD'. */
export const today = (): string => new Date(Date.now() + 7 * 3600000).toISOString().slice(0, 10);
export const addDays = (d: string, n: number): string =>
  new Date(Date.parse(`${d}T00:00:00Z`) + n * 86400000).toISOString().slice(0, 10);

export const initials = (s: unknown): string =>
  String(s || '?')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase();

/** Query string dari objek (nilai kosong/false dibuang). */
export const qs = (o: Record<string, unknown>): string =>
  Object.entries(o)
    .filter(([, v]) => v !== '' && v != null && v !== false)
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`)
    .join('&');

/** Kelas lebar persen dibulatkan 5 (w0…w100). */
export const pctW = (v: number | null | undefined): string => `w${Math.max(0, Math.min(100, Math.round((v || 0) / 5) * 5))}`;

/** Salam sesuai jam WIB. */
export const greet = (): string => {
  const h = new Date(Date.now() + 7 * 3600000).getUTCHours();
  return h < 11 ? 'Selamat pagi' : h < 15 ? 'Selamat siang' : h < 18 ? 'Selamat sore' : 'Selamat malam';
};

/** Qty untuk ditampilkan di kolom input (koma desimal). */
export const qtyInput = (q: number): string => String(q).replace('.', ',');
